import { Tooltip } from '@svetoch/ui';
import { useDataFreshness, type DataFreshnessTarget } from './useDataFreshness';
import './data-freshness.css';

export interface DataFreshnessIndicatorProps {
  target: DataFreshnessTarget;
  label?: string;
  className?: string;
  side?: 'top' | 'right' | 'bottom' | 'left';
}

export function DataFreshnessIndicator({ target, label = 'Данные', className, side = 'bottom' }: DataFreshnessIndicatorProps) {
  const freshness = useDataFreshness(target);
  return <Tooltip side={side} content={<span className="data-freshness-tooltip">
    <strong>{freshness.tooltipTitle}</strong>
    <span>{freshness.tooltipDescription}</span>
  </span>}>
    <button
      type="button"
      className={['data-freshness-indicator', className].filter(Boolean).join(' ')}
      data-freshness={freshness.state}
      data-freshness-reason={freshness.reason}
      aria-label={`${label}. ${freshness.tooltipTitle}. ${freshness.tooltipDescription}`}
      aria-disabled={!freshness.canRefresh || undefined}
      aria-busy={freshness.refreshing || undefined}
      onClick={() => {
        if (freshness.canRefresh) {
          // QueryCache retains the error and drives the visible red state.
          void freshness.refresh().catch(() => undefined);
        }
      }}
    ><span className="data-freshness-dot" aria-hidden="true" /></button>
  </Tooltip>;
}
